import * as React from "react";
import { SingleNavMenuLink as ISingleNavMenuLink } from "../../../pages/identity/useNavMenu";
import { SingleNavMenuLink } from "./singleNavMenuLink";
import { useSingleNavMenuFixedScroll } from "./useSingleNavMenuFixedScroll";
import { SingleNavMenuContextProvider } from "./SingleNavMenuContextProvider";
import { useSingleNavMenuActiveLink } from "./useSingleNavMenuActiveLink";
import { useSingleNavMenuUpdateUrlWithScroll } from "./useSingleNavMenuUpdateUrlWithScroll";

interface Props {
  links: ISingleNavMenuLink[];
  useDetailHeader?: boolean;
  pagesWithScrolls?: string[];
}
export const SingleNavMenu: React.FC<Props> = ({ links, useDetailHeader, pagesWithScrolls = [] }) => {
  return (
    <SingleNavMenuContextProvider links={links} pagesWithScrolls={pagesWithScrolls}>
      <SingleNavMenuContextConsumer
        links={links}
        useDetailHeader={useDetailHeader}
        pagesWithScrolls={pagesWithScrolls}
      />
    </SingleNavMenuContextProvider>
  );
};

export const SingleNavMenuContextConsumer: React.FC<Props> = ({ links, useDetailHeader, pagesWithScrolls = [] }) => {
  useSingleNavMenuFixedScroll(useDetailHeader || false);
  useSingleNavMenuActiveLink(links);
  useSingleNavMenuUpdateUrlWithScroll(links, pagesWithScrolls);

  return (
    <div
      className={`singlenav-backdrop`}
      style={{
        minWidth: 200,
        maxWidth: 200,
      }}
    >
      <nav
        style={{
          minWidth: 200,
          maxWidth: 200,
          overflowY: "auto",
        }}
      >
        {links.map((link, index) => (
          // TODO add an id to use as a key for a link
          <SingleNavMenuLink key={index} link={link} index={index} />
        ))}
      </nav>
    </div>
  );
};
